import {
  Container,
  Box,
  Typography,
  Stack,
  useMediaQuery,
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

export default function About({ txt, txtAr, image, title }) {
  const matches = useMediaQuery("(min-width:1090px)");
  const mm = useMediaQuery("(min-width:679px)");
  const mmm = useMediaQuery("(min-width:530px)");

  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  return (
    <div
      style={{ position: "relative", marginTop: "120px" }}
      dir={isArabic ? "rtl" : "ltr"}
      id={t("About")}
    >
      <Container
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: "center",
          padding: "20px",
        }}
      >
        <Box
          sx={{
            height: matches ? "350px" : "640px",
            width: "100%",
            bgcolor: "#F3F2F21F",
            borderRadius: "20px",
            padding: "20px",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
          }}
        ></Box>
        <Box
          sx={{
            width: matches ? "60%" : "85%",
            bgcolor: "#F3F2F261",
            borderRadius: "20px",
            padding: "20px",
            position: "absolute",
            bottom: matches ? "" : "40px",
            filter: "blur(0px)",
            height: matches ? "fit-content" : mm ? "600px" : "610px",
          }}
        >
          <Typography
            sx={{
              display: "flex",
              color: "white",
              fontSize: matches ? "35px" : "20px",
              flexWrap: "wrap",
              justifyContent: "center",
              alignItems: "center",
              mb: "10px",
            }}
          >
            {t(title)}
          </Typography>
          <Stack direction={matches ? "row" : "column"}>
            <Typography
              sx={{
                marginTop: matches ? "0px" : "0px",
                color: "white",
                fontSize: matches
                  ? "20px"
                  : mm
                  ? "20px"
                  : mmm
                  ? "20px"
                  : "16px",
              }}
            >
              {isArabic ? txtAr : txt}
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                alt="about-img"
                src={image}
                style={{
                  height: matches
                    ? "20rem"
                    : mm
                    ? "20rem"
                    : mmm
                    ? "15rem"
                    : "13rem",
                  width: matches ? "19rem" : "100%",
                  objectFit: "contain",
                }}
              />
            </Box>
          </Stack>
        </Box>
      </Container>
    </div>
  );
}
